<template>
  <div>

    <div class="text-nowrap">
      <b-link v-b-modal="'modalVisitsOverview' + tour.id" @click.stop>{{tour.visits4Show.length}}</b-link> ({{tour.pickups}}&#8593; - {{tour.dropoffs}}&#8595;)
    </div>

    <div class="text-nowrap">
      {{tour.total_distance || '-'}} km.
    </div>

    <div class="text-nowrap" v-translate="{etc: moment().startOf('day').add(tour.estimated_completion_time, 'minutes').format(tour.estimated_completion_time < 60 ? 'm' : 'hh:mm') + (tour.estimated_completion_time < 60 ? ' min' : ' hs')}">
      ETC: %{etc}
    </div>

    <b-modal :id="'modalVisitsOverview' + tour.id" size="lg" :ref="'modalVisitsOverview' + tour.id" @hide="currentVisits4Show = []" hide-footer>
      <template #modal-title><translate>Visits Overview</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <b-card v-for="(visit, index) in tour.visits4Show" :key="index" :class="visit.visited === 1 ? 'bg-success text-light' : ''">
        <b-row>
          <b-col cols="1">
            <h2>{{index + 1}}</h2>
          </b-col>
          <b-col cols="11">
            <shipping-visit :visit="visit" with-ids />
          </b-col>
        </b-row>
      </b-card>
    </b-modal>

  </div>
</template>

<script>
import ShippingVisit from '@/components/Shippings/Visit'

export default {
  name: 'ToursListItemStops',
  components: {
    ShippingVisit
  },
  props: {
    tour: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>
